import { IEnumeration } from '@bp/shared/models/core/enum';

export const BNPL_PSEUDO_PAYMENT_OPTION: IEnumeration = {
	name: 'bnpl',
	displayName: 'BNPL',
	valueOf() {
		return this.name;
	},
};
